import { createSelector } from 'reselect'

export const dhiTransitsPdfStateSelector = state => state.dhiTransitsPdf
export const dhiTransitsPdfSelector = createSelector(dhiTransitsPdfStateSelector)
